import React from "react";

const DashWalletIcon = ({ width, height, color }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7678 4H2.82012V2H18.7678V4ZM18.7678 14H2.82012V8H18.7678V14ZM18.7678 0H2.82012C1.71375 0 0.82666 0.89 0.82666 2V14C0.82666 14.5304 1.03669 15.0391 1.41053 15.4142C1.78438 15.7893 2.29142 16 2.82012 16H18.7678C19.2965 16 19.8036 15.7893 20.1774 15.4142C20.5513 15.0391 20.7613 14.5304 20.7613 14V2C20.7613 0.89 19.8642 0 18.7678 0ZM5.81032 18H7.80378V20H5.81032V18ZM9.79725 18H11.7907V20H9.79725V18ZM13.7842 18H15.7776V20H13.7842V18Z"
        fill={color || "#828282"}
      />
    </svg>
  );
};

export default DashWalletIcon;
